import DashboardJettyAPI from './dashboard-jetty.api'

export default DashboardJettyAPI
